export default "__VITE_ASSET__Ce3ty6rh__"